import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CommandContribution, CommandRegistry } from '@patsnap/tahiti-core';
import { ShareLinkDialogService } from '../share-link-dialog-service';

/**
 * 分享链接命令贡献
 */
@injectable()
export class ShareLinkCommandContribution implements CommandContribution {
    constructor(
        @inject(ShareLinkDialogService)
        private readonly _shareLinkDialogService: ShareLinkDialogService,
    ) {}

    /**
     * 处理分享链接命令
     */
    private async _handleShareLink(): Promise<void> {
        await this._shareLinkDialogService.open({});
    }

    /**
     * 注册命令
     * @param commands - 命令注册器
     */
    registerCommands(commands: CommandRegistry): void {
        // 注册打开分享对话框命令
        commands.registerCommand({
            id: 'share-link:open',
        }, {
            execute: async () => {
                await this._handleShareLink();
            },
        });
    }
}

/**
 * 扩展 CommandService 类型定义
 */
declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开分享链接对话框
         * @param commandId - 命令ID
         */
        executeCommand(commandId: 'share-link:open'): Promise<void>;
    }
}
